export default {"src":"/_next/static/media/card-placeholder-5.37a10c00.svg","height":162,"width":231,"blurWidth":0,"blurHeight":0};